import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { AppAuthServiceService } from '@core';
import fadeIn from 'src/app/shared/animations/fadeIn.animation';
@Component({
    selector: 'ups-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class LoginComponent implements OnInit {
  public redirecting: boolean = true;

  constructor(
    private authService: MsalService,
    private appAuthService: AppAuthServiceService,
    private router: Router,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) {}

  ngOnInit(): void {
    this.appAuthService.isReady.subscribe(() => {
      if (this.appAuthService.isLoggedIn.getValue()) {
        this.redirectToHome();
      } else {
        this.login();
      }
    });
  }

  public login() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  private redirectToHome() {
    if (this.appAuthService.isLoggedIn.getValue()) {
      this.router.navigate(['/home']);
    } else {
      this.redirecting = false;
    }
  }
}
